module.exports = __webpack_public_path__ + "img/topSon.7961a717.svg";